import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export const DEBOUNCE_INPUT_CHANGES_MS = 300;

export type FilterItemsEvent = { filterTerm?: string };

/**
 * Component providing a text-input for filtering list items
 */
@Component({
  selector: 'rl-items-filter',
  templateUrl: './items-filter.component.html',
})
export class ItemsFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() filterText?: string;
  @Output() applyTextFilter = new EventEmitter<FilterItemsEvent>();

  private filterEventSubscription: Subscription;

  itemsFilterForm = new FormGroup({
    filterTerm: new FormControl(),
  });

  private get filterTermForm(): FormControl {
    return this.itemsFilterForm.get('filterTerm') as FormControl;
  }

  ngOnDestroy() {
    if (this.filterEventSubscription) {
      this.filterEventSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.filterEventSubscription = this.filterTermForm.valueChanges
      .pipe(debounceTime(DEBOUNCE_INPUT_CHANGES_MS), distinctUntilChanged())
      .subscribe(filterTerm => {
        this.applyTextFilter.emit({ filterTerm });
      });
  }

  ngOnChanges() {
    if (!this.filterText) {
      // If the filter term has been cleared down externally (see 'clearTextFilter'
      // in the list-alerts component) then reset the form
      this.filterTermForm.reset();
    }
  }
}
